import PropTypes from 'prop-types';
import { MdPersonSearch, MdPersonAddAlt1 } from "react-icons/md";
import { FaArrowLeft, FaChevronRight } from "react-icons/fa";
function OptionCard({ icon, title, subtitle, onClick, accent = "blue", disabled = false, loading = false }) {
  const variant = accent === "green" ? "ui-option--green" : "ui-option--blue";
  return (
    <button
      type="button"
      className={`ui-option ${variant}`}
      onClick={onClick}
      disabled={disabled}
    >
      <div className="ui-option__icon">{icon}</div>
      <div className="ui-option__text">
        <div className="ui-option__title">{title}</div>
        {subtitle && <div className="ui-option__subtitle">{subtitle}</div>}
      </div>
      <div className="ui-option__chevron">
        {loading ? (
          <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true" />
        ) : (
          <FaChevronRight />
        )}
      </div>
    </button>
  );
}

OptionCard.propTypes = {
  icon: PropTypes.node.isRequired,
  title: PropTypes.string.isRequired,
  subtitle: PropTypes.string,
  onClick: PropTypes.func.isRequired,
  accent: PropTypes.oneOf(['blue', 'green']),
  disabled: PropTypes.bool,
  loading: PropTypes.bool,
};

export default function ChoosePersonOption({
  type,
  onChoose,
  onBack,
  isExisting = true,
  existingLoading = false,
}) {
  const entity = type?.trim() || "Person";
  const showExistingOption = isExisting || existingLoading;
  const existingOptionPending = existingLoading && !isExisting;

  return (
    <section className="ui-panel">
      <header className="ui-panel__header">
        <h3 className="ui-title">Transfer</h3>
        <div className="ui-subtitle">Choose {entity}</div>
      </header>

      <div className="ui-options">
        {showExistingOption && (
          <OptionCard
            accent="blue"
            icon={<MdPersonSearch size={22} />}
            title={`Select Existing ${entity}`}
            subtitle={`Search and pick an existing ${entity.toLowerCase()}.`}
            onClick={() => onChoose("existing")}
            disabled={existingOptionPending}
            loading={existingOptionPending}
          />
        )}

        <OptionCard
          accent="green"
          icon={<MdPersonAddAlt1 size={22} />}
          title={`Add New ${entity}`}
          subtitle={`Create a new ${entity.toLowerCase()} profile.`}
          onClick={() => onChoose("new")}
        />
      </div>

      <div className="ui-actions">
        <button type="button" className="ui-btn" onClick={onBack}>
          <FaArrowLeft />
          Back
        </button>
      </div>
    </section>
  );
}

ChoosePersonOption.propTypes = {
  type: PropTypes.string.isRequired,
  onChoose: PropTypes.func.isRequired,
  onBack: PropTypes.func.isRequired,
  isExisting: PropTypes.bool,
  existingLoading: PropTypes.bool,
};
